module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.linkout ? _vm.url : _vm.homeUrl + _vm.url,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "data-gtm-category": ("p-" + (_vm.gtm.category)),
      "data-gtm-label": _vm.gtm.label,
      "data-gtm-action": _vm.gtm.action
    }
  }, [_vm._v(_vm._s(_vm.name) + "\n  "), (_vm.description) ? _c('div', {
    staticClass: "nav_sub_description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20c2a3e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLink.vue
// module id = 234
// module chunks = 2